const production = process.env.NODE_ENV === 'production'

export default {
    baseUrl: production ? '//im.pcbcart.com/' : '/im/',
    production: production
}


// WEBPACK FOOTER //
// ./src/api.js